/**
 * FikoTolerans Dialog — 1D Tolerans Yığını (Stack-up) UI
 * Ölçü zinciri ekle → worst-case + RSS boşluk/min/max. Montaj/uyum analizi.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TolHalka, toleransHesapla, TolSonuc } from './FikoTolerans';

@Component({
  selector: 'fikoyt-tolerans',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="tl">
    <div class="tl-aciklama">Montaj zincirindeki ölçüleri ekleyin. Yön: boşluğu açan (+) / kapatan (−).</div>
    <div class="tl-th"><span>Ölçü</span><span>Nominal</span><span>± Tol</span><span>Yön</span><span></span></div>
    @for (h of halkalar; track $index) {
      <div class="tl-tr">
        <input [(ngModel)]="h.ad" class="ad">
        <input type="number" [(ngModel)]="h.nominal" (ngModelChange)="hesapla()">
        <input type="number" [(ngModel)]="h.tol" (ngModelChange)="hesapla()" step="0.01" min="0">
        <button class="tl-yon" [class.eksi]="h.yon<0" (click)="yonDegis(h)">{{ h.yon < 0 ? '−' : '+' }}</button>
        <button class="tl-sil" (click)="sil($index)">✕</button>
      </div>
    }
    <button class="tl-mini" (click)="ekle()">＋ Ölçü Ekle</button>

    @if (sonuc) {
      <div class="tl-sonuc">
        <div class="tl-r"><span>Nominal boşluk</span><b>{{ f(sonuc.nominalBosluk) }} mm</b></div>
        <div class="tl-blok wc">
          <div class="tl-bb">En Kötü Durum (Worst-Case)</div>
          <div class="tl-r"><span>± Tolerans</span><b>±{{ f(sonuc.wcTol) }}</b></div>
          <div class="tl-r"><span>Min / Max</span><b>{{ f(sonuc.wcMin) }} / {{ f(sonuc.wcMax) }}</b></div>
        </div>
        <div class="tl-blok rss">
          <div class="tl-bb">İstatistiksel (RSS ±3σ)</div>
          <div class="tl-r"><span>± Tolerans</span><b>±{{ f(sonuc.rssTol) }}</b></div>
          <div class="tl-r"><span>Min / Max</span><b>{{ f(sonuc.rssMin) }} / {{ f(sonuc.rssMax) }}</b></div>
        </div>
        <div class="tl-not" [class.uyari]="sonuc.wcMin < 0">{{ sonuc.wcMin < 0 ? '⚠️ En kötü durumda boşluk negatif — parçalar çakışabilir (girişim).' : '✓ En kötü durumda bile boşluk pozitif.' }}</div>
      </div>
    }
  </div>
  `,
  styles: [`
    .tl { padding:10px; min-width:300px; max-width:340px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .tl-aciklama { font-size:10px; color:#9fe8f7; margin-bottom:8px; line-height:1.4; }
    .tl-th, .tl-tr { display:grid; grid-template-columns:1.4fr 60px 50px 28px 20px; gap:4px; align-items:center; margin-bottom:3px; }
    .tl-th { color:#7fc6dd; font-size:9px; }
    .tl-tr input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; width:100%; }
    .tl-tr input.ad { text-align:left; }
    .tl-yon { background:rgba(0,150,90,.5); border:1px solid rgba(0,255,150,.4); color:#fff; border-radius:4px; cursor:pointer; font-weight:700; }
    .tl-yon.eksi { background:rgba(200,90,40,.5); border-color:rgba(255,150,80,.5); }
    .tl-sil { background:rgba(120,40,40,.6); border:1px solid rgba(255,100,100,.4); color:#ff9a9a; border-radius:4px; cursor:pointer; }
    .tl-mini { width:100%; margin-top:4px; background:rgba(0,90,110,.6); border:1px solid rgba(0,200,220,.4); color:#bdf; border-radius:4px; padding:5px; font-size:10px; cursor:pointer; }
    .tl-mini:hover { background:rgba(0,130,160,.8); }
    .tl-sonuc { margin-top:10px; }
    .tl-r { display:flex; justify-content:space-between; padding:2px 0; } .tl-r span { color:#9fe8f7; }
    .tl-blok { margin-top:6px; padding:6px 8px; border-radius:5px; }
    .tl-blok.wc { background:rgba(255,180,0,.1); border:1px solid rgba(255,180,0,.3); }
    .tl-blok.rss { background:rgba(0,200,220,.1); border:1px solid rgba(0,200,220,.3); }
    .tl-bb { font-size:10px; font-weight:700; color:#ffd76a; margin-bottom:2px; } .tl-blok.rss .tl-bb { color:#6fe0f5; }
    .tl-not { margin-top:8px; padding:6px; border-radius:4px; font-size:10px; text-align:center; background:rgba(0,200,120,.15); color:#9fffc8; }
    .tl-not.uyari { background:rgba(255,70,70,.18); color:#ff9a9a; }
  `]
})
export class FikoToleransComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};

  halkalar: TolHalka[] = [
    { ad: 'Gövde boyu', nominal: 50, tol: 0.1, yon: 1 },
    { ad: 'Mil', nominal: 30, tol: 0.05, yon: -1 },
    { ad: 'Rulman', nominal: 19.5, tol: 0.05, yon: -1 },
  ];
  sonuc: TolSonuc | null = null;

  constructor(private cd: ChangeDetectorRef) { this.sonuc = toleransHesapla(this.halkalar); }

  ekle(): void { this.halkalar.push({ ad: 'Ölçü', nominal: 0, tol: 0.1, yon: 1 }); this.hesapla(); }
  sil(i: number): void { this.halkalar.splice(i, 1); this.hesapla(); }
  yonDegis(h: TolHalka): void { h.yon = h.yon < 0 ? 1 : -1; this.hesapla(); }
  hesapla(): void { this.sonuc = toleransHesapla(this.halkalar); this.cd.detectChanges(); }

  f(v: number, d = 3): string { return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d }); }
}
